export const StepEditMobile = {
  OTP_VERIFICATION: 'otp-verification',
  DOPA_VERIFICATION: 'dopa-verification',
  INPUT_NEW_MOBILE: 'input-new-mobile',
  SHOW_CUSTOMER_LIST: 'show-customer-list',
}
